/**
 * Self-contained build-time feature flag for the GitHub-style Account Switcher
 * (Gordon 2026-07-20). Mirrors LinkedWheels/featureFlag.js so it can be reviewed /
 * merged independently.
 *
 * Defaults OFF; flipped per environment via REACT_APP_ACCOUNT_SWITCHER. When OFF,
 * the avatar-dropdown "Accounts / Switch account" section is never rendered, the
 * account registry is never written, and the app boots/behaves byte-identically to
 * today (the only entry point — <AccountSwitcherSection/> in ProfileMenu — returns
 * null before any registry read/write, and ProfileMenu's mount-time "remember
 * current account" call no-ops).
 *
 * At merge this can be folded into src/constants/featureFlags.js.
 */
const truthy = (v) => v === "true" || v === "1" || v === true;

export const ACCOUNT_SWITCHER_ENABLED = truthy(
  process.env.REACT_APP_ACCOUNT_SWITCHER
);
